import React, { createContext, useState, useEffect } from "react";
import { addDays } from "date-fns";
import dayjs from "dayjs";
import "dayjs/locale/es";
import Cookies from "js-cookie";
import { obtenerDatosHotel } from "../../services/motorService";
import {
  obtenerTarifaPorTipoCliente,
  obtenerMuestroTarifaTipoHab,
} from "../../services/motorService";
import { useLocation } from "react-router-dom";

const RoomTypeRatePlanContext = createContext();

const pad2 = (v) => String(v).padStart(2, "0");

const toYmd = (value) => {
  if (!value) return "";

  if (value?.format && typeof value.format === "function") {
    return value.format("YYYY-MM-DD");
  }

  if (typeof value === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return "";
    return `${parsed.getFullYear()}-${pad2(parsed.getMonth() + 1)}-${pad2(
      parsed.getDate()
    )}`;
  }

  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

export const AppProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState({ cartNoPrice: [], price: 0 });
  const [reservaAdmintour, setReservaAdmintour] = useState(null);
  const [carritoVersion, setCarritoVersion] = useState(0);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hotcodParam = params.get("hotcod");
  const hotCod = hotcodParam ?? Cookies.get("hotCod") ?? null;

  const isHotelConRut = [6, 7, 8, 9, 10].includes(Number(hotCod));

  useEffect(() => {
    console.log("Cart items updated:", cartItems);
  }, [cartItems, reservaAdmintour]);

  const [selectedDetails, setSelectedDetails] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 2),
    roomType: "",
    ratePlan: "",
  });

  const getTarifaParaHabitacion = async (
    roomCount,
    hotCod,
    tipoHabCodigo,
    startDate,
    rutData
  ) => {
    const formattedStartDate = toYmd(startDate);

    if (isHotelConRut && roomCount === 0) {
      const segmentoModel = rutData.segmentoModel || {};
      const tipoCliente = Object.keys(segmentoModel).find(
        (key) => segmentoModel[key] === "X"
      );

      if (tipoCliente) {
        const rate = await obtenerTarifaPorTipoCliente(
          hotCod,
          tipoHabCodigo,
          formattedStartDate,
          tipoCliente
        );
        return rate.TarifaTipoHabItem || [];
      }
    }

    return await obtenerMuestroTarifaTipoHab(
      hotCod,
      tipoHabCodigo,
      formattedStartDate
    );
  };

  useEffect(() => {
    const fetchMinimumNights = async () => {
      try {
        const hotelData = await obtenerDatosHotel(hotCod);
        const minNights = hotelData.motorhotminimonoches || 1;
        const newEndDate = addDays(new Date(), minNights);

        setSelectedDetails((prev) => ({
          ...prev,
          startDate: new Date(),
          endDate: newEndDate,
        }));
      } catch (error) {
        console.error("Error fetching minimum nights:", error);
      }
    };

    fetchMinimumNights();
  }, [hotCod]);

  useEffect(() => {
    console.log("Selected details updated:", selectedDetails);
  }, [selectedDetails]);

  return (
    <RoomTypeRatePlanContext.Provider
      value={{
        selectedDetails,
        setSelectedDetails,
        cartItems,
        setCartItems,
        carritoVersion,
        setCarritoVersion,
        reservaAdmintour,
        setReservaAdmintour,
        getTarifaParaHabitacion,
      }}
    >
      {children}
    </RoomTypeRatePlanContext.Provider>
  );
};

export default RoomTypeRatePlanContext;